import { systemRoutes } from './systemRoutes'
import { companyRoutes } from './companyRoutes'
import { partnerRoutes } from './partnerRoutes'

export default [...systemRoutes, ...companyRoutes, ...partnerRoutes]
